import { PriceSchemeSelectorBase } from './PriceSchemeSelectorBase/PriceSchemeSelectorBase';
import styles from './PriceSchemeSelector.module.scss';

type PriceSchemeSelectorProps = {
  value: string | undefined;
  onChange: (id: string) => void;
};

export const PriceSchemeSelector = ({ value, onChange }: PriceSchemeSelectorProps) => {
  return (
    <PriceSchemeSelectorBase className={styles['restricted-width']} size="xsmall" value={value} onChange={onChange} />
  );
};

export default PriceSchemeSelector;
